import { render, staticRenderFns } from "./ParticipantFollowed.vue?vue&type=template&id=b0f2ce24"
import script from "./ParticipantFollowed.vue?vue&type=script&lang=ts"
export * from "./ParticipantFollowed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports